import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc2016',
    ecrans: ['00-2'],
    params: ['prbcleint']
});
